import Typography from "@portal/components/atoms/v2/typography";
import Icon from "../icons";
import { TextResources } from "@portal/assets/text/TextResources";
import Illustration from "../illustrations";

interface Props {
  text: string | undefined;
  small?: boolean;
  userAvatar?: boolean;
  corporateUser?: boolean;
  showHat?: boolean;
  highLighted?: boolean;
  disabled?: boolean;
}

/**
 * Component for a circle with an abbreviation of a name.
 * @param interface
 * @returns a circle with an abbreviation.
 */
export const AvatarComponent = ({
  text,
  small,
  userAvatar,
  corporateUser,
  showHat = false,
  highLighted = false,
  disabled = false,
}: Props) => {
  const abbreviation = userAvatar ? GetUserInitials(text) : GetAccountInitials(text);
  const variant = small ? "DescriptionSmall" : "Bold";

  return (
    <div className={`flex relative ${disabled ? "opacity-60" : ""}`}>
      <div className={`${!showHat ? "hidden" : ""} absolute ${small ? "-top-4" : "-top-4 left-0.5"}  text-red`}>
        <Illustration name="santaHatIcon" size="small" />
        {/* <Illustration name="easterBunnyFoldedEarsIcon" size="small" /> */}
      </div>
      <div
        className={`flex justify-center items-center ${small ? "h-7.5 w-7.5" : "h-9.25 w-9.25"} ${userAvatar ? "bg-inverseMenuBackground text-inverseMenuText hover:bg-menuHover" : "bg-primary text-accountMenuText dark:bg-inverseMenuBackground dark:text-inverseMenuText dark:hover:bg-menuHover"} rounded-full transition-colors ease-in-out duration-100 ${highLighted ? "border-2 border-greenHighlighted" : ""}`}
      >
        {corporateUser ? (
          <Icon name="buildingOfficeIcon" size="small" />
        ) : (
          <Typography variant={variant}>{abbreviation}</Typography>
        )}
      </div>
    </div>
  );
};

const GetAccountInitials = (taxationType: string | undefined) => {
  return taxationType !== "" ? taxationType : TextResources.ACCOUNT_DEFAULT_AVATAR;
};

const GetUserInitials = (userName: string | undefined) => {
  if (!userName) return "";
  const initials = userName
    ?.trim()
    .split(" ")
    .map(n => n[0]);
  if (!initials) return "";
  if (initials.length > 2) return `${initials[0]}${initials[initials.length - 1]}`;
  if (initials.length === 1) return `${initials[0]}`;

  return `${initials[0]}${initials[1]}`;
};
